import React from "react";

export default function Label({
  className = "input-group__label",
  children,
  disabled,
}) {
  return (
    <div className={className + (disabled ? " is-disabled" : "")}>
      {children}
    </div>
  );
}
